var map = {
	"./search-results.de-CH.json": 919,
	"./search-results.de-DE.json": 920,
	"./search-results.en-CA.json": 921,
	"./search-results.en-GB.json": 922,
	"./search-results.en-IN.json": 923,
	"./search-results.en-ME.json": 924,
	"./search-results.en-US.json": 925,
	"./search-results.es-EM.json": 926,
	"./search-results.es-ES.json": 927,
	"./search-results.fr-BE.json": 928,
	"./search-results.fr-CA.json": 929,
	"./search-results.fr-CH.json": 930,
	"./search-results.nl-BE.json": 931,
	"./search-results.nl-NL.json": 932,
	"./search-results.pl-PL.json": 933,
	"./search-results.pt-BR.json": 934
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 918;